module.exports = __webpack_public_path__ + "img/hexagonal_gazebo.863c4f13.jpg";